import { useEffect } from "react"
import { useLocation } from "react-router-dom"

const ScrollToTop = () => {
  const { pathname } = useLocation()

  //-tự động cuộn trang về đầu mỗi khi route thay đổi
  useEffect(() => {
    document.body.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
